/**
 * Converts data validation error messages to object.
 * @param errors 
 */
export function getErrorMessagePair (errors) {
    return  Object.assign(
        ...errors.map(({ field, message }) => ({ [field]: message }))
    )
}
